import { embedFilter } from '../sharedFilters'

const DATASET_KEY = 'security_managment_employee'

export default {
  key: 'security_managment_employee',
  label: 'GSMS - Employee',
  timeColumn: 'security_managment_employee.created_at',
  permission: { action: 'reporting', subject: 'Widget' },

  tables: {
    security_managment_employee: ["id", "soeid", "prim_prfer_fst_nm", "prim_prfer_lst_nm", "prim_scnd_lst_nm", "bus_email_addr", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  csvConfig: {
    withTables: 'security_managment_employee',
    columns: '',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'security_managment_employee.bus_email_addr', label: 'Email' },
    { key: 'security_managment_employee.soeid', label: 'SOEID' },
    { key: 'security_managment_employee.created_at', label: 'Fecha de creacion', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    embedFilter(DATASET_KEY, 'security_managment_employee.bus_email_addr', 'Email', 'name'),
    embedFilter(DATASET_KEY, 'security_managment_employee.soeid', 'SOEID', 'reference'),
  ],

    dateGrouping: {
    column: 'security_managment_employee.created_at',
    presets: [
      { value: '1d', label: 'Dia' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Anio' },
    ],
  },
}
